export default {
    props: {},
    data () {
        return {};
    },
    computed: {
        urlParams () {
            return {
                module: "sheet",
                name: "index"
            };
        }
    },
    methods: {
        // 接口 -拖动
        handleDrag (callback, dataItem) {
            return this.$https({
                url: {
                    ...this.urlParams,
                    name: "update"
                },
                messageTip: "拖动成功！",
                params: {
                    ...dataItem,
                    screenKey: this.screenKey
                },
                callback: data => {
                    callback ? callback(dataItem) : this.dragCb(dataItem);
                }
            });
        },
        // 接口 -删除数据
        handleBatchDelete (deleteIds = this.selectIds) {
            this.$httpDelete({
                url: {
                    ...this.urlParams,
                    name: "delete"
                },
                params: {
                    search: {
                        _id: {
                            "$in": deleteIds
                        }
                    },
                    screenKey: this.screenKey
                },
                messageTip: "删除成功！",
                callback: datas => {
                    this.deleteCb && this.deleteCb(datas);
                }
            });
        }
    }
};



// WEBPACK FOOTER //
// ./src/mixins/sheet/base/sheetInterfaceMixin.js